// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

// @flow
import queryString from 'query-string'
import config from '../config'

export function APIUrl (path: string, args: Object, api) {
  const params = queryString.stringify({
    ...args.queryParams
  })
  return `${config[api]}${path}?${params}`
}

export function APIHeaders (session: Object) {
  if (session.token) {
    return {Authorization: `${session.token}`,
      'Content-Type': 'application/json'}
  }
  return {}
}
